import Vue from 'vue';
import feathersClient from '../../feathers-client';


const defaultEligilableCandidatesListPagination = {
	total: 100,
	$skip: 0,
	$limit: 10,
};
const defaultEligilableCandidatesListPaginationFilter = {
	$skip: defaultEligilableCandidatesListPagination.$skip,
	$limit: defaultEligilableCandidatesListPagination.$limit,
};
 export default {
	state: {
		selectedJob: null,
		defaultWeightSettings: null,
		adjustedWeightSettings:null,
		eligibleCandidates: [],
		filterAvailibility: null,
		filterSkills: [],
		eligibleCandidatesPagination:defaultEligilableCandidatesListPagination,
		eligibleCandidatesFilter: defaultEligilableCandidatesListPaginationFilter,
		loaderIsActive: false,
	},
	getters: {
		selectedJob: (state) => state.selectedJob,
		eligibleCandidates:(state) => state.eligibleCandidates,
		defaultWeightSettings:(state) => state.defaultWeightSettings,
		adjustedWeightSettings:(state) => state.adjustedWeightSettings,
		filterAvailibility: (state) => state.filterAvailibility,
		filterSkills: (state) => state.filterSkills,
		eligibleCandidatesPage: (state) => {
			const { $limit, $skip } = state.eligibleCandidatesPagination;
			return $skip / $limit + 1;
		},
		loaderIsActive: (state) => state.loaderIsActive,
	},
	mutations: {
		SET_SELECTED_JOB: (state, data ) => {state.selectedJob = data;},
		SET_ELIGIBLE_CANDIDATES: (state, data)=> {state.eligibleCandidates = data;},
		DEFAULT_WEIGHT_SETTINGS:(state, data) => {state.defaultWeightSettings = data;},
		ADJUSTED_WEIGHT_SETTINGS: (state, data) => {state.adjustedWeightSettings = data;},
		SET_AVAILABILITY_FILTER: (state, data) => {state.filterAvailibility = data;},
		SET_SKILLS_FILTER: (state,data) => {state.filterSkills = data ;},
		SET_ELIGIBLE_CANDIDATES_PAGINATION : (	state, data) => {state.eligibleCandidatesPagination = {...state.eligibleCandidatesPagination,...data}; },
		SET_ELIGIBLE_CANDIDATES_FILTER: (state, data) => {state.eligibleCandidatesFilter= {...state.eligibleCandidatesFilter,...data};},
		SET_LOADER: (state, data) => {state.loaderIsActive = data;}

	},
	actions: {
		setEligibleCandidatesPage: ({commit, state},page )=>{
			const $skip =( page-1) * state.eligibleCandidatesPagination.$limit;
			commit('SET_ELIGIBLE_CANDIDATES_PAGINATION', {$skip});
			commit('SET_ELIGIBLE_CANDIDATES_FILTER',{$skip});
		},
		setAdjustedSettings:({commit}, data) => {
			commit('ADJUSTED_WEIGHT_SETTINGS', data);
		},
		loadEligibalCandidates :async ({rootGetters,commit}, filter) => {
			const url = '/api/v3/get-staff-match-score';
			const filterData = {
				jobId: filter.id,
				fields: ["users"],
				...filter.filter,
				$role: rootGetters.currentUserRole,
				deleted: true,
			};
			if (filter?.skillsWeight && filter?.localExpWeight && filter?.learningWeight && filter?.fairnessWeight) {
				filterData.skillsWeight = filter.skillsWeight;
				filterData.localExpWeight = filter.localExpWeight;
				filterData.learningWeight = filter.learningWeight;
				filterData.fairnessWeight = filter.fairnessWeight;
			}
			const response = await feathersClient.service('api/v3/get-staff-match-score').find({
				query: filterData });
			commit ('SET_ELIGIBLE_CANDIDATES',response.data);
			commit('SET_ELIGIBLE_CANDIDATES_PAGINATION', {total: response.total})
			return response;
		},
		asssignShiftById: async ({rootGetters},data) => {
			const url = '/api/v3/applications'
			const response = await feathersClient.service(url).create(data,{
				query:{
					$role: rootGetters.currentUserRole
				}
			});
			return response;
		}
	},

 };
